import { Lookup } from '../../../shared/model/lookup';

export class NmfcClass extends Lookup {
  constructor(code: string, name: string) {
    super(code, name);
  }
}
